export enum READER_RESUME_SOURCE {
    unspecified = 'unspecified',
    authLockAuto = 'auth-lock-auto',
    resumeButton = 'resume-button',
    userReaderProgress = 'user-reader-progress',
    localReaderProgress = 'local-reader-progress',
}
